import { Button, Input } from "rizzui";
import { PiMagnifyingGlassBold, PiPlusBold } from "react-icons/pi";
import { Link } from "react-router-dom";
import { routes } from "@/config/routes";
import StatusPromotion from "./status-promotion";
import { EPromotionStatus } from "@/utilities/types/Promotion";

export default function FilterElement({
  onSearch,
  searchTerm,
  status,
  updateFilter,
}: {
  onSearch: (searchTerm: string) => void;
  searchTerm: string;
  status?: EPromotionStatus;
  updateFilter: (key: string, value: any) => void;
  variant?: string;
}) {
  function clearSearch() {
    onSearch("");
  }

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 lg:flex-nowrap mb-3">
      <div className="flex w-full items-center gap-3 md:w-auto">
        <Input
          type="search"
          placeholder="Search by name..."
          value={searchTerm}
          onClear={clearSearch}
          onChange={(e) => onSearch(e.target.value)}
          clearable={true}
          prefix={<PiMagnifyingGlassBold className="h-4 w-4" />}
          className="w-full"
        />
        {/* <StatusPromotion
          status={status}
          onChange={(value) => {
            updateFilter("status", value);
          }}
          className="min-w-[150px] [&_.select-container]:!h-10 [&_.rizzui-select-button]:!h-full"
          clearable
        /> */}
      </div>
      <Link to={routes.promotion.create} className="w-full md:w-auto">
        <Button as="span" className="w-full md:w-auto" variant="solid">
          <PiPlusBold className="me-1.5 h-[17px] w-[17px]" />
          Add Promotion
        </Button>
      </Link>
    </div>
  );
}
